"use strict";var e=require("styled-components").css`
    list-style: none;
    margin: 0;
    padding: 6px;
    background: ${({theme:e})=>e.colors.common.light};
    border-radius: ${({theme:e})=>`0 0 ${e.borderRadiuses.small} ${e.borderRadiuses.small}`};
    box-shadow: ${({theme:e})=>e.shadows.low};
    width: 100%;
    z-index: 100;
    outline: none;
    display: grid;
    grid-auto-flow: row;
    grid-row-gap: 2px;
`;module.exports=e;
//# sourceMappingURL=styles.js.map
